export default {

  errorDefault: "Ocurrió un error inesperado, intente más tarde.",
  succesDefault: "Se completo con éxito la operación",

};

